import React, { Component } from "react";
import CustomFunctions from "../../../modules/functions";
import ReactDOM from "react-dom";
import ErrorPage from "./errorPage";
import Themes from "../../themes";
import { BrowserRouter } from "react-router-dom";
import Functions from "../../../src/functions";

class SubmitPaymentInfo extends Component {
	state = {
		data: [],
		control: null,
		loaded: false,
		clicked: false,
	};

	constructor(props) {
		super(props);

		this.handler = this.handler.bind(this);
	}

	componentDidMount() {
		this.setState({
			control: this.props.control,
			loaded: true,
			data: this.props.data,
			clicked: false,
		});
	}
	checkBoxListener() {
		if (!document.getElementsByClassName("checkbox active")[0]) {
			document.getElementsByClassName("checkbox")[0].className =
				"checkbox active";
		} else {
			document.getElementsByClassName("checkbox active")[0].className =
				"checkbox";
		}
	}
	handler() {
		let valid = true;
		let email = document.getElementsByClassName("frm-email")[0];
		let terms = document.getElementsByClassName("checkbox")[0];
		let error_message = "Συμπληρώστε έγκυρο email & αποδεχτείτε τους όρους.";
		let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
		if (!regex.test(email.value)) {
			document.getElementsByClassName("row")[0].className = "row error";
			valid = false;
		} else {
			document.getElementsByClassName("row")[0].className = "row";
		}
		if (terms.className === "checkbox") {
			document.getElementsByClassName("terms")[0].className = "row terms error";
			valid = false;
		} else {
			document.getElementsByClassName("terms")[0].className = "row terms";
		}
		if (valid) {
			document.getElementsByClassName("error-message")[0].innerHTML = "";
			let UserType = Functions["custom"]["getUserType"]();
			let amount = sessionStorage.getItem("amount");
			let rli = sessionStorage.getItem("rli");
			let serviceId =
				UserType === "HYBRID_BUSINESS_COST_CONTROL"
					? JSON.parse(sessionStorage.modalData).modal.mtbServiceID
					: this.state.data[0].serviceId.data.serviceId;
			let email = document.getElementsByClassName("frm-email")[0].value;

			let paymentRequest = {
				amount: amount,
				serviceId: serviceId,
				email: email,
				rli: rli,
			};

			const url = CustomFunctions.restAPI("/cards/payment/initiate");
			fetch(url, {
				method: "POST",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
				},
				body: JSON.stringify(paymentRequest),
			})
				.then((res) => res.json())
				.then((data) => {
					if (data.status === "OK") {
						window.location = data.redirectUrl;
					} else {
						console.log(
							"ERROR: paymentBegin:error on Rest response status:" +
								data.status,
						);
					}
				})
				.catch((error) => {
					window.location.replace("/error");
				});
			//landing.prepaid.paymentService.paymentBegin(amount, serviceId, email, rli);
		} else {
			document.getElementsByClassName("error-message")[0].innerHTML =
				error_message;
		}
	}

	render() {
		if (this.state.loaded) {
			let dataFromLocal = JSON.parse(sessionStorage.modalData);
			let img = "";
			if (dataFromLocal.type === "EXTRA") {
				img = <img src="../../../resources/prepaid/images/30d_new.png" />;
			} else if (dataFromLocal.type === "GIGA_WEEK") {
				img = <img src="../../../resources/prepaid/images/7M_NEW.png" />;
			} else if (dataFromLocal.type === "HOURS") {
				img = <img src="../../../resources/prepaid/images/24W_NEW.png" />;
			}
			return (
				<div>
					<div className="header">
						<div className="hold">
							<a className="logo addCursorPointer"></a>
						</div>
					</div>
					<div className="card-updates submit-payment-info">
						<div className="top">
							<div className="holder">
								<a
									href="/"
									className="back">
									← Πίσω
								</a>
								<div className="product">
									<div className="product-title">
										{sessionStorage.getItem("busServiceDes")}
									</div>
									<div
										className="product-icon"
										style={{ zIndex: 0 }}>
										{img}
									</div>
								</div>
							</div>
						</div>
						<div className="title">Εισάγετε email</div>
						<div className="text">
							Εισάγετε το email σας για να λαβετε το αποδεικτικό της αγοράς σας.
						</div>
						<div className="form">
							<div className="row">
								<div className="error-message"></div>
								<input
									type="email"
									className="frm-email"
								/>
							</div>
							<div className="text">
								Στην τελική τιμή χρέωσης θα συμπεριληφθεί και τέλος Κινητής 10%,
								εκτός εάν η σύνδεση δικαιούται απαλλαγής (0%) λόγω της εγγραφής
								της στην ειδική εφαρμογή του gov.gr για φυσικά πρόσωπα δεκαπέντε
								(15) έως και είκοσι εννέα (29) ετών.
							</div>
							<div className="row terms">
								<a
									onClick={this.checkBoxListener}
									className="checkbox"
									style={{ cursor: "pointer" }}></a>{" "}
								Αποδέχομαι τους {this.state.data[0].showTerms.component} και ότι
								με την ενεργοποίηση του πακέτου θα απωλέσω το δικαίωμα της
								υπαναχώρησης του νόμου 2251/1994 περί προστασίας του καταναλωτή.
							</div>
							<div className="row">
								<a
									onClick={this.handler}
									className="submit"
									style={{ cursor: "pointer" }}>
									Συνέχεια
								</a>
							</div>
						</div>
					</div>
				</div>
			);
		} else {
			return "";
		}
	}
}

export default SubmitPaymentInfo;
